export default function () {

  const head = document.head;
  head.insertAdjacentHTML('beforeend', '<link rel="stylesheet" type="text/css" href="//cdnjs.cloudflare.com/ajax/libs/cookieconsent2/3.1.0/cookieconsent.min.css">');

  let script = document.createElement('script');
  script.onload = () => {
    window.addEventListener('load', () => {
      window.cookieconsent.initialise({
        'palette': {
          'popup': {
            'background': '#000'
          },
          'button': {
            'background': '#f1d600'
          }
        },
        'theme': 'classic',
        'position': 'bottom-right',
        'content': {
          'message': 'Si informa che questo sito utilizza cookie, anche di terze parti anonimizzati. ' +
            'Continuando a navigare su questo sito, si acconsente all’utilizzo dei cookie. ' +
            'Consultare la ' +
            '<a aria-label="Informazioni sui cookies" role="button" tabindex="0" class="cc-link" ' +
              'href="/privacy-policy" rel="noopener noreferrer nofollow">pagina di informativa sulla privacy</a> '+
            ' se si desidera saperne di più oppure ' +
            'se si vuole negare il consenso a tutti o ad alcuni cookie',
          'dismiss': 'Ho capito',
          'link': null,
          'href': null
        }
      });
    });
  };
  script.src = '//cdnjs.cloudflare.com/ajax/libs/cookieconsent2/3.1.0/cookieconsent.min.js';
  script.type = 'text/javascript';
  head.appendChild(script);
}

